import { darken, lighten, transparentize } from 'polished';

const baseColors = {
  primary: '#7CC25B',
  secondary: '#F16100',
  tertiary: '#af504c'
};

const statusColors = {
  info: '#2c662d',
  ok: '#2c662d',
  warn: '#f2c037',
  error: '#9f3a38'
};

const statusBgColors = {
  info: lighten(0.3, statusColors.info),
  warn: lighten(0.3, statusColors.warn),
  error: lighten(0.3, statusColors.error)
};

const greyColors = {
  grey: '#767676',
  greyLighter: '#b8b8b8',
  greyLightest: '#e7e7e7',
  greyDarker: '#3b3b3b',
  greyDarkest: '#181818'
};

const neutralColors = {
  fullBlack: '#000000',
  offWhite: '#f9fafb',
  darkWhite: '#f3f4f5',
  midWhite: '#dcddde',
  white: '#ffffff'
};

const backgroundColors = {
  primary: lighten(0.35, baseColors.primary),
  secondary: lighten(0.35, baseColors.secondary)
};
const darkColors = {
  primary: darken(0.07, baseColors.primary),
  secondary: darken(0.07, baseColors.secondary)
};

const lightColors = {
  primary: lighten(0.08, baseColors.primary),
  secondary: lighten(0.08, baseColors.secondary)
};

const transparentColors = {
  grey: transparentize(0.4, greyColors.greyDarker),
  error: transparentize(0.4, statusBgColors.error)
};

export const colors = {
  base: baseColors,
  grey: greyColors,
  neutral: neutralColors,
  background: backgroundColors,
  status: statusColors,
  statusBg: statusBgColors,
  dark: darkColors,
  light: lightColors,
  transparent: transparentColors
};

export type Colors = typeof colors;
